export default __webpack_public_path__ + "static/media/inspector-layer-group.9796dc14.svg";